import { Outlet, ScrollRestoration } from "react-router-dom";
import ScrollToTop from "../shared/ScrollToTop";
import Seo from "../shared/Seo";
import Navbar from "./Navbar";
import Footer from "./Footer";
import LiveChat from "./LiveChat";
import SizingBoard from "./SizingBoard";
import { useContext } from "react";
import { ToggleContext } from "../../../ToggleProvider";
import { useSelector } from "react-redux";
import { useLocation } from 'react-router-dom';
import CriteoOneTag from "../shared/CriteoOneTag";
import { siteApi } from "../../../services/site";
import SiteUnavailable from "./SiteUnavailable";

export default function RootLayout() {
    const { isToggled, setIsToggled } = useContext(ToggleContext);
    const loginUser = useSelector(state => state.userReducer.user);
    const { pathname } = useLocation();
    const siteId = useSelector(state => state.commonReducer.siteId);
    // Read-only: subscribing here would refetch a failed site-config on every mount and loop with App's loading screen.
     const { isError: isSiteInfoError } = siteApi.endpoints.getSiteInfo.useQueryState(undefined);

    return (
        <>
            <CriteoOneTag />
            <Seo />
            <Navbar />
            {isToggled && loginUser.UserID && pathname !== '/login' &&
                <SizingBoard key={siteId} siteId={siteId} />
            }
            {isSiteInfoError ? <SiteUnavailable /> : <Outlet />}
            <Footer />
            {loginUser.UserID &&
                <LiveChat />
            }
            <ScrollRestoration />
        </>
    );
}